import { Box } from "@chakra-ui/react";

function CategoryPreviewWrapper({ children }) {
  return (
    <Box
      flexGrow="1"
      overflowY="auto"
      overflowX="visible"
      paddingBlockEnd="4"
      paddingInline="2"
      marginBlockStart="4"
      height={"calc(100% - var(--chakra-space-12))"}
    >
      {children}
    </Box>
  );
}

export default CategoryPreviewWrapper;